import hrms1axLabels from 'assets/labels/hrms1ax'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hrms1axLabels
    }
  },
  index () {
    let mockRows = []
    const mockCodempid = [ '33175', '33139', '57011', '57008' ]
    const mockLocation = [ 'เยาวราช', 'เอเชียทีค เดอะริเวอร์ฟร้อนท์', 'จตุจักร', 'โอเชี่ยนทาวเวอร์ 2' ]
    const mockCheckin = [ 'static/images/city/city1.jpg', 'static/images/city/city2.jpg', 'static/images/city/city3.jpg', 'static/images/city/city4.jpg' ]
    const mockCodpos = [ 'Software Tester', 'Programmer', 'Sr.Maketing', 'System Engineer' ]
    const mockCodcomp = [ 'แผนกดำเนินการ', 'ส่วนการตลาด', 'แผนก Coding & Modify', 'แผนก Technical Support' ]
    const mockCoordinates = [ '13.741006, 100.5086', '13.703823,100.504045', '13.799847, 100.549391', '13.703823,100.504145' ]
    const mockTotal = 4
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: mockCodempid[i - 1],
        desc_codempid: faker.name.findName(),
        codpos: '',
        desc_codpos: mockCodpos[i - 1],
        codcomp: '',
        desc_codcomp: mockCodcomp[i - 1],
        dtework: moment(faker.date.past()).format('DD/MM/YYYY'),
        typwork: 'W',
        codshift: 'D1',
        timbstr: '09:00',
        timbend: '18:00',
        timdstr: faker.date.past().toString().substr(16, 5),
        timdend: faker.date.past().toString().substr(16, 5),
        location: mockLocation[i - 1],
        reason: 'reason',
        coordinates: mockCoordinates[i - 1],
        filenamei: mockCheckin[i - 1],
        filenameo: mockCheckin[i - 1]
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms1ax/mocker.js